export enum MpProductTypeEnum  {
  NONE = 'none',
  JOB = 'job',
  ARTICLE = 'article',
  WIZARD = 'wizard'
}
